import React from "react";
import { Button, DatePicker, Form, Drawer, Icon } from "antd";
import moment from "moment";
import { useDispatch } from "react-redux";

import { loadBankStatements } from "../actions";

var RangePicker = DatePicker.RangePicker;

var DrawerFilter = function(props) {
    var form = props.form;
    var getFieldDecorator = form.getFieldDecorator;
    var validateFields = form.validateFields;
    var visible = props.visible;
    var setVisible = props.setVisible;
    var initialValues = props.initialValues || {};
    var from = initialValues.from;
    var to = initialValues.to;

    var dispatch = useDispatch();

    var handleFilter = function(e) {
        e.preventDefault();

        validateFields(function(err, values) {
            if (err) return;

            dispatch(loadBankStatements({
                from: values.period[0].format("YYYY-MM-DD"),
                to: values.period[1].format("YYYY-MM-DD"),
                status: 'reconciled',
                view: 'period',
            }));
            setVisible(false);
        });
    };

    var rangeConfig = {
        initialValue: [moment(from), moment(to)],
        rules: [{ type: 'array', required: true, message: 'Por favor, selecione um período!' }],
    };

    return (
        <Drawer
            title="Selecionar Período"
            placement="right"
            closable={true}
            onClose={function() { setVisible(false); }}
            visible={visible}
            width={400}
        >
            <Form onSubmit={handleFilter}>
                <Form.Item label="Período:">
                    {getFieldDecorator('period', rangeConfig)(
                        <RangePicker
                            format="DD/MM/YYYY"
                            style={{ width: '100%' }}
                            ranges={{
                                "Hoje": [moment(), moment()],
                                "Últimos 7 dias": [moment().subtract(7, 'days'), moment()],
                                "Últimos 30 dias": [moment().subtract(30, 'days'), moment()],
                                "Este mês": [moment().startOf('month'), moment().endOf('month')],
                                "Mês passado": [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                                "Últimos 3 meses": [moment().subtract(3, 'months').startOf('month'), moment()],
                                "Últimos 6 meses": [moment().subtract(6, 'months').startOf('month'), moment()],
                                "Este ano": [moment().startOf('year'), moment().endOf('year')],
                                "Ano passado": [moment().subtract(1, 'year').startOf('year'), moment().subtract(1, 'year').endOf('year')],
                            }}
                        />
                    )}
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit" block>
                        <Icon type="search" /> Aplicar Filtro
                    </Button>
                </Form.Item>
            </Form>
        </Drawer>
    );
};

export default Form.create()(DrawerFilter);
